import { BaseCarousel, type BaseCarouselConfig, type CarouselInstance } from '../base-carousel';

export class RgsToursCarousel extends BaseCarousel {
  protected getDefaultConfig(): BaseCarouselConfig {
    return {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 400,
      autoplay: false,
      pagination: false,
      navigation: false,
      mousewheel: false
    };
  }

  protected buildSwiperConfig(container: HTMLElement, config: BaseCarouselConfig): any {
    const swiperConfig = super.buildSwiperConfig(container, config);
    
    // Add nested carousel specific options
    swiperConfig.direction = 'horizontal';
    swiperConfig.nested = true;
    swiperConfig.allowTouchMove = true;
    swiperConfig.simulateTouch = true;
    
    return swiperConfig;
  }

  protected attachCustomEventHandlers(carouselInstance: CarouselInstance, selector: string): void {
    if (!carouselInstance.swiperInstance) return;

    // For parent carousel, prevent movement when touching inner carousel
    if (selector === '.carousel__container__rgs') {
      carouselInstance.swiperInstance.on('touchStart', (swiper, event) => {
        const target = event.target as HTMLElement;
        const innerCarousel = target.closest('.carousel__container__rgs-images');
        
        if (innerCarousel) {
          swiper.allowTouchMove = false;
        }
      });
      
      carouselInstance.swiperInstance.on('touchEnd', (swiper) => {
        swiper.allowTouchMove = true;
      });
    }
  }
}

export const RGS_TOURS_CAROUSEL_CONFIG: Partial<BaseCarouselConfig> = {
  slidesPerView: 1.1,
  spaceBetween: 10,
  loop: true,
  speed: 400,
  autoplay: false,
  pagination: false,
  navigation: true,
  breakpoints: {
    768: {
      slidesPerView: 2.15
    },
    1440: {
      slidesPerView: 2.2
    }
  },
  mousewheel: true
};

export const RGS_IMAGES_CAROUSEL_CONFIG: Partial<BaseCarouselConfig> = {
  slidesPerView: 1,
  spaceBetween: 0,
  loop: true,
  speed: 600,
  autoplay: false,
  pagination: true,
  navigation: false,
  mousewheel: true
};

const rgsToursCarousel = new RgsToursCarousel();

export function initRgsToursCarousel(): void {
  rgsToursCarousel.init('.carousel__container__rgs', RGS_TOURS_CAROUSEL_CONFIG);
}

export function initRgsImagesCarousel(): void {
  rgsToursCarousel.init('.carousel__container__rgs-images', RGS_IMAGES_CAROUSEL_CONFIG);
}

export { rgsToursCarousel };

